export const navLinks = [
  { id: "featured", label: "精选合集" },
  { id: "categories", label: "主题分类" },
  { id: "wallpapers", label: "壁纸专区" },
  { id: "lifestyle", label: "生活记录" },
  { id: "guide", label: "风格指南" },
  { id: "faq", label: "常见问题" },
];

export const heroStats = [
  { value: "120+", label: "收录合集" },
  { value: "8", label: "主题分类" },
  { value: "6", label: "壁纸尺寸" },
  { value: "3", label: "每周更新" },
];

export const heroTags = [
  "高清写真",
  "日常自拍",
  "手机壁纸",
  "桌面壁纸",
  "室内人像",
  "户外旅拍",
];

export const featuredItems = [
  {
    id: "f1",
    title: "都市午后·光影写真",
    desc: "傍晚斜阳下的城市街景，暖调光线与简洁穿搭相互呼应，适合作为写真类合集的入门浏览。",
    count: "36 张",
    tag: "高清写真",
    image:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20portrait%20photography%20of%20an%20elegant%20asian%20woman%20in%20a%20minimalist%20city%20street%20at%20golden%20hour%2C%20soft%20natural%20light%2C%20cream%20and%20terracotta%20tones%2C%20shallow%20depth%20of%20field%2C%20refined%20composition%2C%20high%20detail&width=800&height=600&seq=ylwm-feat-01&orientation=landscape",
  },
  {
    id: "f2",
    title: "居家日常·温柔自拍",
    desc: "自然光下的生活化记录，表情松弛、背景干净，记录状态最真实的一面，适合日常浏览收藏。",
    count: "48 张",
    tag: "日常自拍",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20lifestyle%20self%20portrait%20of%20a%20woman%20at%20home%20near%20a%20large%20window%2C%20soft%20morning%20light%2C%20warm%20neutral%20interior%20with%20linen%20and%20wood%2C%20relaxed%20natural%20expression%2C%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=ylwm-feat-02&orientation=landscape",
  },
  {
    id: "f3",
    title: "秋日旅拍·街角漫步",
    desc: "旅行途中随手拍下的片段，落叶、长椅与小巷构成背景，色调偏暖，适合寻找壁纸素材时参考。",
    count: "52 张",
    tag: "户外旅拍",
    image:
      "https://readdy.ai/api/search-image?query=autumn%20travel%20portrait%20of%20an%20elegant%20woman%20walking%20along%20a%20quiet%20old%20street%20with%20fallen%20leaves%2C%20warm%20amber%20afternoon%20light%2C%20soft%20bokeh%20background%2C%20editorial%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=600&seq=ylwm-feat-03&orientation=landscape",
  },
  {
    id: "f4",
    title: "咖啡时光·室内人像",
    desc: "窗边座位、木质桌面与一杯热饮，室内暖光把氛围拉满，属于耐看的日常人像类型。",
    count: "29 张",
    tag: "室内人像",
    image:
      "https://readdy.ai/api/search-image?query=indoor%20cafe%20portrait%20of%20an%20elegant%20asian%20woman%20sitting%20by%20the%20window%20with%20a%20cup%20of%20coffee%2C%20warm%20ambient%20light%2C%20wooden%20table%20and%20soft%20cream%20tones%2C%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=ylwm-feat-04&orientation=landscape",
  },
  {
    id: "f5",
    title: "纯色背景·质感肖像",
    desc: "以米色、藕粉等纯色背景突出人物，光线干净柔和，构图规整，适合做头像或壁纸素材。",
    count: "41 张",
    tag: "高清写真",
    image:
      "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20an%20elegant%20woman%20on%20a%20soft%20beige%20seamless%20background%2C%20clean%20diffused%20lighting%2C%20refined%20pale%20pink%20and%20cream%20palette%2C%20editorial%20photography%2C%20centered%20composition%2C%20high%20detail&width=800&height=600&seq=ylwm-feat-05&orientation=landscape",
  },
  {
    id: "f6",
    title: "窗边阅读·安静时刻",
    desc: "午后靠在窗边翻书的画面，光影落在书页和侧脸，整体安静克制，属于氛围感较强的一组。",
    count: "33 张",
    tag: "日常自拍",
    image:
      "https://readdy.ai/api/search-image?query=quiet%20afternoon%20portrait%20of%20a%20woman%20reading%20a%20book%20beside%20a%20bright%20window%2C%20soft%20natural%20light%20on%20pages%20and%20profile%2C%20warm%20cream%20minimal%20interior%2C%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=ylwm-feat-06&orientation=landscape",
  },
];

export const galleryCategories = [
  { id: "all", label: "全部" },
  { id: "hd", label: "高清写真" },
  { id: "selfie", label: "日常自拍" },
  { id: "indoor", label: "室内人像" },
  { id: "outdoor", label: "户外旅拍" },
  { id: "mobile", label: "手机壁纸" },
  { id: "desktop", label: "桌面壁纸" },
];

export const galleryItems = [
  {
    id: "g01",
    title: "晨光窗台",
    category: "selfie",
    desc: "醒来后的第一缕日光，素颜状态下的自然记录。",
    resolution: "1600 × 2000",
    image:
      "https://readdy.ai/api/search-image?query=soft%20morning%20portrait%20of%20a%20woman%20by%20a%20sunlit%20windowsill%2C%20warm%20gentle%20light%2C%20cream%20linen%20curtains%2C%20natural%20relaxed%20mood%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=ylwm-gal-01&orientation=portrait",
  },
  {
    id: "g02",
    title: "米色肖像",
    category: "hd",
    desc: "纯色背景拍摄的定妆肖像，光线均匀，细节清晰。",
    resolution: "2400 × 3000",
    image:
      "https://readdy.ai/api/search-image?query=clean%20studio%20portrait%20of%20an%20elegant%20woman%20on%20a%20warm%20beige%20backdrop%2C%20even%20soft%20lighting%2C%20refined%20cream%20palette%2C%20editorial%20photography%2C%20high%20detail%2C%20centered%20composition&width=600&height=800&seq=ylwm-gal-02&orientation=portrait",
  },
  {
    id: "g03",
    title: "沙发一角",
    category: "indoor",
    desc: "居家客厅的随手拍，暖色灯光把房间衬得很柔和。",
    resolution: "1800 × 2400",
    image:
      "https://readdy.ai/api/search-image?query=casual%20indoor%20portrait%20of%20a%20woman%20relaxing%20on%20a%20linen%20sofa%20in%20a%20warm%20living%20room%2C%20soft%20lamp%20light%2C%20beige%20and%20terracotta%20tones%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=ylwm-gal-03&orientation=portrait",
  },
  {
    id: "g04",
    title: "雨后街道",
    category: "outdoor",
    desc: "雨后湿润的街面反射着街灯光，氛围安静惬意。",
    resolution: "2000 × 2600",
    image:
      "https://readdy.ai/api/search-image?query=urban%20portrait%20of%20an%20elegant%20woman%20on%20a%20wet%20city%20street%20after%20rain%2C%20reflections%20of%20warm%20lamplight%2C%20muted%20amber%20tones%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=ylwm-gal-04&orientation=portrait",
  },
  {
    id: "g05",
    title: "竖向手机壁纸",
    category: "mobile",
    desc: "为竖屏比例裁剪，留白充足，适合直接设为锁屏。",
    resolution: "1170 × 2532",
    image:
      "https://readdy.ai/api/search-image?query=minimal%20vertical%20portrait%20wallpaper%20of%20an%20elegant%20woman%20with%20generous%20negative%20space%2C%20soft%20cream%20and%20warm%20beige%20tones%2C%20clean%20composition%2C%20editorial%20photography%2C%20high%20detail&width=480&height=960&seq=ylwm-gal-05&orientation=portrait",
  },
  {
    id: "g06",
    title: "横版桌面壁纸",
    category: "desktop",
    desc: "宽幅构图，主体偏置，桌面图标不会挡住人物。",
    resolution: "2560 × 1440",
    image:
      "https://readdy.ai/api/search-image?query=wide%20desktop%20wallpaper%20featuring%20an%20elegant%20woman%20on%20one%20side%20with%20open%20space%2C%20warm%20cream%20and%20terracotta%20palette%2C%20editorial%20photography%2C%20high%20detail&width=1024&height=576&seq=ylwm-gal-06&orientation=landscape",
  },
  {
    id: "g07",
    title: "窗光侧影",
    category: "indoor",
    desc: "侧逆光勾勒轮廓，明暗过渡自然，适合安静氛围。",
    resolution: "1800 × 2400",
    image:
      "https://readdy.ai/api/search-image?query=moody%20indoor%20portrait%20of%20a%20woman%20in%20profile%20silhouetted%20by%20bright%20window%20light%2C%20soft%20shadow%20gradient%2C%20warm%20neutral%20interior%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=ylwm-gal-07&orientation=portrait",
  },
  {
    id: "g08",
    title: "海边微风",
    category: "outdoor",
    desc: "海风吹动头发与衣角，色调清淡，适合夏天浏览。",
    resolution: "2000 × 2600",
    image:
      "https://readdy.ai/api/search-image?query=seaside%20portrait%20of%20an%20elegant%20woman%20with%20wind%20in%20her%20hair%2C%20soft%20overcast%20light%2C%20pale%20sand%20and%20warm%20cream%20tones%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=ylwm-gal-08&orientation=portrait",
  },
  {
    id: "g09",
    title: "对镜自拍",
    category: "selfie",
    desc: "镜面前的自拍记录，背景干净，光线均匀柔和。",
    resolution: "1600 × 2000",
    image:
      "https://readdy.ai/api/search-image?query=mirror%20self%20portrait%20of%20a%20woman%20in%20a%20minimal%20warm%20room%2C%20even%20soft%20lighting%2C%20clean%20beige%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=ylwm-gal-09&orientation=portrait",
  },
  {
    id: "g10",
    title: "暗调质感",
    category: "hd",
    desc: "低亮度背景配合柔和补光，质感与层次兼备。",
    resolution: "2400 × 3000",
    image:
      "https://readdy.ai/api/search-image?query=low%20key%20studio%20portrait%20of%20an%20elegant%20woman%20with%20soft%20fill%20light%2C%20rich%20texture%20and%20depth%2C%20warm%20deep%20brown%20tones%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=ylwm-gal-10&orientation=portrait",
  },
  {
    id: "g11",
    title: "竖屏渐变壁纸",
    category: "mobile",
    desc: "干净留白搭配暖色渐变，图标辨识度更高。",
    resolution: "1080 × 2340",
    image:
      "https://readdy.ai/api/search-image?query=vertical%20mobile%20wallpaper%20with%20a%20gentle%20warm%20cream%20and%20amber%20gradient%20and%20a%20subtle%20portrait%20of%20a%20woman%2C%20generous%20empty%20space%2C%20refined%20minimal%20composition%2C%20high%20detail&width=480&height=960&seq=ylwm-gal-11&orientation=portrait",
  },
  {
    id: "g12",
    title: "宽屏留白",
    category: "desktop",
    desc: "大面积留白加小面积主体，长时间盯着屏幕也舒服。",
    resolution: "3840 × 2160",
    image:
      "https://readdy.ai/api/search-image?query=ultrawide%20minimal%20desktop%20wallpaper%20with%20large%20negative%20space%20and%20a%20small%20elegant%20figure%2C%20warm%20cream%20and%20soft%20amber%20tones%2C%20editorial%20photography%2C%20high%20detail&width=1024&height=576&seq=ylwm-gal-12&orientation=landscape",
  },
];

export const desktopWallpapers = [
  {
    id: "w-d1",
    title: "暖阳宽屏",
    resolution: "2560 × 1440",
    note: "常见 16:9 显示器比例，主体居中偏右。",
    image:
      "https://readdy.ai/api/search-image?query=elegant%20wide%20desktop%20wallpaper%20of%20a%20woman%20in%20warm%20sunlight%20near%20a%20window%2C%20cream%20and%20terracotta%20palette%2C%20open%20negative%20space%20for%20icons%2C%20editorial%20photography%2C%20high%20detail&width=1024&height=576&seq=ylwm-wall-d1&orientation=landscape",
  },
  {
    id: "w-d2",
    title: "极简桌面",
    resolution: "3840 × 2160",
    note: "4K 超宽比例，风格克制，适合办公桌面。",
    image:
      "https://readdy.ai/api/search-image?query=minimal%204k%20desktop%20wallpaper%20with%20a%20subtle%20portrait%20on%20the%20left%20and%20soft%20cream%20gradient%2C%20warm%20neutral%20tones%2C%20clean%20refined%20composition%2C%20high%20detail&width=1024&height=576&seq=ylwm-wall-d2&orientation=landscape",
  },
  {
    id: "w-d3",
    title: "暖棕质感",
    resolution: "1920 × 1080",
    note: "深暖色背景，长时间使用不易疲劳。",
    image:
      "https://readdy.ai/api/search-image?query=warm%20brown%20toned%20desktop%20wallpaper%20with%20an%20elegant%20woman%20and%20soft%20window%20light%2C%20rich%20texture%2C%20muted%20amber%20palette%2C%20editorial%20photography%2C%20high%20detail&width=1024&height=576&seq=ylwm-wall-d3&orientation=landscape",
  },
];

export const mobileWallpapers = [
  {
    id: "w-m1",
    title: "竖屏留白",
    resolution: "1170 × 2532",
    note: "顶部留白，避开状态栏与时间显示。",
    image:
      "https://readdy.ai/api/search-image?query=vertical%20phone%20wallpaper%20with%20a%20soft%20portrait%20of%20a%20woman%20in%20the%20lower%20half%20and%20open%20space%20at%20top%2C%20warm%20cream%20tones%2C%20refined%20minimal%20composition%2C%20high%20detail&width=480&height=960&seq=ylwm-wall-m1&orientation=portrait",
  },
  {
    id: "w-m2",
    title: "暖色渐变",
    resolution: "1080 × 2340",
    note: "渐变色打底，图标与小组件辨识度更高。",
    image:
      "https://readdy.ai/api/search-image?query=phone%20wallpaper%20with%20a%20smooth%20warm%20amber%20to%20cream%20gradient%20and%20a%20faint%20portrait%2C%20clean%20minimal%20design%2C%20high%20detail%2C%20soft%20texture&width=480&height=960&seq=ylwm-wall-m2&orientation=portrait",
  },
  {
    id: "w-m3",
    title: "素色锁屏",
    resolution: "1440 × 3120",
    note: "高分辨率竖屏，细节保留完整。",
    image:
      "https://readdy.ai/api/search-image?query=high%20resolution%20vertical%20lock%20screen%20wallpaper%20of%20an%20elegant%20woman%20in%20soft%20neutral%20tones%2C%20clean%20cream%20background%2C%20editorial%20photography%2C%20high%20detail%2C%20refined&width=480&height=960&seq=ylwm-wall-m3&orientation=portrait",
  },
];

export const lifestyleEntries = [
  {
    id: "l1",
    month: "10 月",
    title: "换季整理 · 衣橱与状态",
    desc: "天气转凉后拍摄的一组室内记录，穿搭以针织与米色系为主，光线偏暖，整体节奏安静，适合当成季节转换时浏览的合集。",
    meta: "室内 · 18 张 · 暖调",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20autumn%20indoor%20lifestyle%20portrait%20of%20a%20woman%20in%20a%20knit%20sweater%20by%20warm%20light%2C%20cream%20and%20beige%20interior%2C%20calm%20natural%20mood%2C%20editorial%20photography%2C%20high%20detail&width=700&height=520&seq=ylwm-life-01&orientation=landscape",
  },
  {
    id: "l2",
    month: "09 月",
    title: "周末小旅行 · 沿海公路",
    desc: "沿公路自驾途中拍下的片段，天空偏灰但光线柔和，人物与风景比例均衡，附带少量窗外抓拍，浏览时按时间顺序排列。",
    meta: "户外 · 26 张 · 清冷",
    image:
      "https://readdy.ai/api/search-image?query=travel%20lifestyle%20portrait%20of%20a%20woman%20on%20a%20coastal%20road%20trip%2C%20soft%20overcast%20light%2C%20muted%20sand%20and%20cream%20tones%2C%20editorial%20photography%2C%20high%20detail&width=700&height=520&seq=ylwm-life-02&orientation=landscape",
  },
  {
    id: "l3",
    month: "08 月",
    title: "午后书房 · 安静阅读",
    desc: "在书房窗边完成的日常拍摄，以纸本书籍与木质桌面为背景，光线充足、构图平稳，适合需要长时间查看细节的场景。",
    meta: "室内 · 14 张 · 明亮",
    image:
      "https://readdy.ai/api/search-image?query=bright%20study%20room%20lifestyle%20portrait%20of%20a%20woman%20reading%20by%20a%20window%2C%20warm%20wooden%20desk%20and%20books%2C%20soft%20cream%20light%2C%20editorial%20photography%2C%20high%20detail&width=700&height=520&seq=ylwm-life-03&orientation=landscape",
  },
  {
    id: "l4",
    month: "07 月",
    title: "夜市漫步 · 街灯与蝉鸣",
    desc: "夜间街拍为主，依靠街灯与店铺灯箱照明，画面颗粒感略强但氛围感突出，与白天合集的风格形成明显对比。",
    meta: "户外 · 22 张 · 夜景",
    image:
      "https://readdy.ai/api/search-image?query=night%20street%20portrait%20of%20an%20elegant%20woman%20in%20a%20night%20market%2C%20warm%20shop%20and%20lamp%20light%2C%20muted%20amber%20tones%2C%20editorial%20photography%2C%20high%20detail&width=700&height=520&seq=ylwm-life-04&orientation=landscape",
  },
];

export const styleGuides = [
  {
    id: "s1",
    icon: "ri-sun-line",
    title: "自然光拍摄",
    desc: "利用窗边与清晨傍晚的柔和光线，避免直射强光，肤色过渡更自然，也是本站写真类合集最常见的用光方式。",
    points: ["窗边侧光最稳", "清晨傍晚更柔和", "避免正午顶光"],
  },
  {
    id: "s2",
    icon: "ri-layout-masonry-line",
    title: "构图与留白",
    desc: "人物不必总在正中，适当偏置并保留大面积留白，既方便裁切为壁纸，也让画面更有呼吸感与观看节奏。",
    points: ["主体偏置更耐看", "留白方便做壁纸", "视线方向留空间"],
  },
  {
    id: "s3",
    icon: "ri-palette-line",
    title: "配色与氛围",
    desc: "整体以米色、藕粉、暖棕等低饱和暖色为主，背景与服装色调保持接近，画面统一，长时间浏览也不容易视觉疲劳。",
    points: ["低饱和暖色打底", "背景服装同色系", "避免高对比撞色"],
  },
  {
    id: "s4",
    icon: "ri-crop-line",
    title: "尺寸与裁剪",
    desc: "同一个合集往往同时提供横版与竖版比例，横版用于桌面壁纸，竖版用于手机锁屏，裁剪时优先保证主体完整。",
    points: ["桌面用 16:9 横版", "手机用 9:19.5 竖版", "裁剪保留完整主体"],
  },
];

export const browseTips = [
  {
    id: "t1",
    icon: "ri-filter-3-line",
    title: "先按主题筛选",
    desc: "在「主题分类」区域选择想看的方向，列表会即时收敛，避免在大批内容里反复翻找。",
  },
  {
    id: "t2",
    icon: "ri-image-line",
    title: "优先看高清写真",
    desc: "想收藏或当素材时，优先浏览分辨率更高的写真类合集，细节保留更完整。",
  },
  {
    id: "t3",
    icon: "ri-smartphone-line",
    title: "壁纸按屏幕挑",
    desc: "手机选竖版、电脑选横版，壁纸专区已按比例分组，尺寸信息都标注在卡片上。",
  },
  {
    id: "t4",
    icon: "ri-time-line",
    title: "关注更新时间",
    desc: "生活记录按月份整理，越靠前越新，想追更可以直接从这一区域看起。",
  },
  {
    id: "t5",
    icon: "ri-bookmark-3-line",
    title: "收藏常用入口",
    desc: "把本页加入书签，之后从导航直接跳到对应分区，省去每次重新搜索的时间。",
  },
];

export const faqItems = [
  {
    id: "q1",
    q: "这个页面主要提供什么内容？",
    a: "本页把与「年轻的岳母」相关的图片资源集中整理，按高清写真、日常自拍、室内人像、户外旅拍以及手机与桌面壁纸等主题分类呈现，方便在一个页面内快速浏览与定位。",
  },
  {
    id: "q2",
    q: "想看某个特定风格，怎么找更快？",
    a: "可以在「主题分类」区域切换标签，页面会即时筛选出对应内容；也可以参考「风格指南」，里面说明了自然光、构图、配色与尺寸四类常见风格特征，方便你判断哪一种更符合需求。",
  },
  {
    id: "q3",
    q: "壁纸应该选横版还是竖版？",
    a: "手机锁屏与主屏一般使用竖版比例，电脑桌面使用横版比例。壁纸专区已经按这两类分组，并标注了分辨率，选择与设备屏幕接近的尺寸效果最好。",
  },
  {
    id: "q4",
    q: "页面内容会更新吗？",
    a: "会。生活记录区域按月份整理，越靠前的条目越新，新增内容通常先出现在该区域，再补充到对应的主题分类中。",
  },
  {
    id: "q5",
    q: "可以用在个人设备上收藏吗？",
    a: "可以。本页仅作资源整理与浏览入口，你可以把喜欢的合集加入书签或保存到本地，用于个人设备上的壁纸与浏览。",
  },
  {
    id: "q6",
    q: "为什么有些图片标注了不同分辨率？",
    a: "不同合集最初的拍摄与整理尺寸不同，为了方便选择，我们在卡片上直接标出分辨率，分辨率越高越适合大屏或需要放大查看的场景。",
  },
];